import { Box, Skeleton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import { Y_AXIS_WIDTH } from "~/feature/chart/constants";

export const Root = styled(Box)(({ theme }) => ({
  height: 22,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(0, 1.5),
  paddingLeft: `calc(${theme.spacing(1.5)} + ${Y_AXIS_WIDTH}px)`,
}));

export const Tick = styled(Typography)(({ theme }) => ({
  fontSize: 11,
  color: theme.palette.text.disabled,
  whiteSpace: "nowrap",
}));

export const TickSkeleton = styled(Skeleton)({
  width: 38,
  height: 11,
  transform: "none",
});
